<template>
  <div class="testlist">
    <Header></Header>
    <Title title="考试列表"></Title>
    <div class="contain_main">
      <div class="search" @keydown.enter="changepage(1)">
        <div class="search_item">
          <div class="item">
            <span>考试名称:</span>
            <Input v-model="data.examtitle" placeholder="请输入..." style="width:2rem"/>
          </div>
          <div class="item">
            <span>考试状态:</span>
            <Select v-model="data.status" style="width:1rem">
              <Option value="0">全部</Option>
              <Option value="1">未开始</Option>
              <Option value="2">进行中</Option>
              <Option value="3">已结束</Option>
            </Select>
          </div>
          <div class="item">
            <div class="button" @click="changepage(1)">搜索</div>
          </div>
          <div class="item" style="margin-left:1rem">
            <div @click="$router.push('/manage/publicpaper')" class="button">发布考试</div>
          </div>
        </div>
      </div>
      <div class="table">
        <table>
          <thead>
            <tr>
              <td>考试编号</td>
              <td>考试名称</td>
              <td>考试开始时间</td>
              <td>考试结束时间</td>
              <td>需要登录</td>
              <td>考试状态</td>
              <td>阅卷状态</td>
              <td>参考人数</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody>
            <!-- total	number	true	参考人数
            examdecide	number	true	0需阅卷1无需阅卷
            examislogin	number	true	0无需登陆1需要登陆
            examendtime	number	true	考试结束时间
            examstartime	number	true	考试开始时间
            examtitle	string	true	考试标题
            exampid	number	true	试卷id
            examid	number	true	考试id-->
            <tr v-for="(item,index) in list" :key="index">
              <td>{{item.examid}}</td>
              <td>
                <Tooltip :content="item.examtitle" placement="top-start">
                  <span class="tableName">{{item.examtitle}}</span>
                </Tooltip>
              </td>
              <td>{{item.examstartime|formatetime}}</td>
              <td>{{item.examendtime|formatetime}}</td>
              <td>{{item.examislogin|islogin}}</td>
              <td>{{timedesc(item.examstartime,item.examendtime)}}</td>
              <td>{{item.total==0?'无需阅卷':isdecide(item.less)}}</td>
              <td>{{item.total}}</td>
              <td>
                <button class="pri" @click="url(item.examid,item.examislogin)">链接</button>
                <button class="blue" @click="edit(item.examid)">编辑</button>
                <button class="orange" @click="copy(item.examid)">复制</button>
                <button class="green" @click="totongji(item.examid,item.total,item.less,item.ehtype)">统计</button>
                <button class="red" @click="govered(item.examid,item.examdecide,item.total)">阅卷</button>
                <button @click="del(item.examid)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class style="text-align:right;margin-top:20px;">
        <Page
          :total="total"
          :current="data.page"
          :page-size="data.size"
          @on-change="changepage"
          @on-page-size-change="changesize"
          show-sizer
          show-elevator
          show-total
          :page-size-opts="[5,10, 20,50]"
        />
      </div>
    </div>
    <div></div>
  </div>
</template>
<script>
import Header from "../../components/header";
import Title from "../../components/title";

import {
  ExamPaper_index,
  Exam_copy,
  Exam_delExam,
  Exam_check
} from "../../assets/js/api.js";
export default {
  name: "examlists",
  data() {
    return {
      value: null,
      model1: null,
      total: null,
      data: {
        examtitle: "", //	string	true	普通参数		考试名称
        status: "0", //	string	true	普通参数		1未开始2考试中3已结束
        page: 1, //	string	true	普通参数		页码
        size: 10 //	string	true	普通参数		条数
      },
      list: []
    };
  },
  filters: {
    islogin(data) {
      // 0无需登陆1需要登陆
      if (data == 0) {
        return "否";
      } else if (data == 1) {
        return "是";
      }
    }
  },
  mounted() {
    if (this.$route.query.page && this.$route.query.size) {
      this.data.page = this.$route.query.page - 0;
      this.data.size = this.$route.query.size - 0;
    }
    this.getlist();
  },
  components: {
    Header,
    Title
  },
  methods: {
    timedesc(start, end) {
      if (start) {
        var nowdate = new Date();
        var nowdatetime = nowdate.getTime() / 1000;
        if (nowdatetime < Number(start)) {
          return "未开始";
        } else if (nowdatetime < Number(end)) {
          return "进行中";
        } else {
          return "已结束";
        }
      } else {
        return "进行中";
      }
    },
    isdecide(data) {
      if (data > 0) {
        return "阅卷中";
      } else {
        return "阅卷完成";
      }
    },
    changepage(data) {
      this.data.page = data;
      // this.getlist();
      this.$router.push({
        path: "/managelist",
        query: {
          page: this.data.page,
          size: this.data.size
        }
      });
      this.getlist();
    },
    changesize(data) {
      this.data.page = 1;
      this.data.size = data;
      // this.getlist();
      this.$router.push({
        path: "/managelist",
        query: {
          page: this.data.page,
          size: this.data.size
        }
      });
      this.getlist();
    },
    getlist() {
      ExamPaper_index(this.data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.total = res.data.data.count;
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    },
    edit(id) {
      this.$router.push("/manage/publicpaper?id=" + id);
    },
    copy(id) {
      // Exam_copy({ id: examid }).then(res => {
      //   if (res.data.code == 200) {
      //     this.$Notice.success({ title: '成功提示',desc:'复制成功！'});;
      //     this.getlist();
      //     return;
      //   }
      //      this.$Notice.warning({ title: "信息提示", desc: res.data.message });;
      // });
      this.$router.push("/manage/publicpaper?copy=1&id=" + id);
    },
    url(data, islogin) {
      if (islogin != "0") {
        this.$Notice.warning({
          title: "信息提示",
          desc: "此考试需要登录，无需链接！"
        });
        return;
      }
      // 复制url
      var oInput = document.createElement("input");
      oInput.value = window.location.origin + "/#/login?id=" + data;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      this.$Notice.success({ title: "成功提示", desc: "复制成功！" });
    },
    del(data) {
      if (!confirm("您确定删除该考试？")) {
        return;
      }
      Exam_delExam({ examid: data }).then(res => {
        if (res.data.code == 200) {
          this.$Notice.success({ title: "成功提示", desc: "删除成功！" });
          this.getlist();
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    },
    govered(id, decide, total) {
      if (decide || !total) {
        this.$Notice.warning({ title: "信息提示", desc: "无需阅卷！" });
        return;
      }
      // 考试中检查---用于拦截
      Exam_check({ examid: id }).then(res => {
        if (res.data.code == 200) {
          this.$router.push("/gooverpaper?id=" + id);
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    },
    totongji(id, data, less, type) {
      if (type == 3) {
        this.$Notice.warning({
          title: "信息提示",
          desc: "随机试卷不开放统计！"
        });
        return;
      }
      if (data == 0) {
        this.$Notice.warning({
          title: "信息提示",
          desc: "参考人数为零，无法统计！"
        });
        return;
      }
      if (less > 0) {
        this.$Notice.warning({
          title: "信息提示",
          desc: "请阅卷完成后查看统计！"
        });
        return;
      }
      this.$router.push("/anaslyse?id=" + id);
    }
  }
};
</script>
<style lang="css" scoped>
/* 搜索栏样式------------------------------------------------------------------------------------------- */
.search {
  margin-top: 0.2rem;
  display: flex;
  color: #575e6b;
}
.search .search_item {
  display: flex;
}
.search .search_item .item {
  margin: 0 0.15rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
/* 表格栏目样式----------------------------------------------------------------------------------------------*/
.table {
  margin-top: 0.6rem;
  font-size: 0.14rem;
}
table {
  width: 100%;
}
thead tr {
  color: #a4acbf;
}
tbody tr {
  color: #707788;
}
tr {
  height: 0.6rem;
}
/*查看详情button-----------------------------------------------------------------------------------------------------------------*/
button {
  border-radius: 0.2rem;
  border: none;
  margin: 0 0.02rem;
  padding: 0.04rem 0.1rem;
  font-size: 0.14rem;
  outline: none;
}
button.blue {
  color: #25b3f9;
  background: #d3f3fc;
}
button.pri {
  color: #e037ff;
  background: #fadfff;
}
button.orange {
  color: #ff8d13;
  background: #ffe2c4;
}
button.green {
  color: #36cd68;
  background: #cffade;
}
button.red {
  color: #ff3a68;
  background: #ffd6de;
}
</style>


// WEBPACK FOOTER //
// src/pages/namnege/manegelist.vue